import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../ui/TextField";

const defaultData = {
  title: "",
  instruction: "",
  fileId:null
};

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 12
  }
});

const Instruction = ({ disabled, onFormChange, initialData, classes, editmode }) => {
  const [data, setData] = React.useState(initialData || defaultData);
  const {
    title,
    instruction,
    fileId
  } = data;

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>Заголовок и инструкция</Typography>
      <TextField
        required
        value={title}
        onChange={e => onChange("title", e.target.value)}
        label="Заголовок"
        disabled={disabled}
        readOnly={!editmode}
      />
      <TextField
        multirow
        value={instruction}
        onChange={e => onChange("instruction", e.target.value)}
        label="Инструкция"
        disabled={disabled}
        readOnly={!editmode}
      />
    </div>
  );
};

export default withStyles(styles)(Instruction);
